import { GLProgram } from "../../../program.js";
export class StampProgram extends GLProgram {

    constructor(gl: any, vertex_source: any, fragment_source: any) {
        super(gl, vertex_source, fragment_source);
    }

    static create(templates, gl) {
        var common_source = templates.get('photoshop/GL/shaders/common.glsl');
        var vertex_source = templates.get('photoshop/GL/shaders/tools/stamp/vertex.glsl');
        var fragment_source = templates.get('photoshop/GL/shaders/tools/stamp/fragment.glsl');
        var result = new StampProgram(gl, vertex_source, common_source + fragment_source);
        result._uniforms['texture'] = gl.getUniformLocation(result._program, 'u_texture');
        result._uniforms['stroke_mask'] = gl.getUniformLocation(result._program, 'u_stroke_mask');
        return result;
    }

    setUniforms(parameters) {
    }

}